import React, { useState } from 'react';
import EditModalWrapper from './EditModalWrapper';

const AddSkillModal = ({
    isOpen,
    onClose,
    onSave,
}) => {
    const [skill, setSkill] = useState('');
    const [proficiency, setProficiency] = useState('Intermediate');
    const [experience, setExperience] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const proficiencyOptions = ['Beginner', 'Intermediate', 'Advanced', 'Expert'];

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!skill.trim()) {
            alert('Skill name is required');
            return;
        }

        setIsSubmitting(true);
        try {
            await onSave({
                name: skill.trim(),
                proficiency,
                years_of_experience: experience
            });
            setSkill(''); // Reset after save
            setProficiency('Intermediate');
            setExperience('');
            onClose();
        } catch (error) {
            console.error('Error saving skill:', error);
            alert('Failed to save skill. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <EditModalWrapper
            isOpen={isOpen}
            onClose={onClose}
            title="Add Skill"
            onSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            submitLabel="Add"
            size="sm"
        >
            <div className="space-y-5">
                <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1.5">
                        Skill Name <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={skill}
                        onChange={(e) => setSkill(e.target.value)}
                        className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition-all bg-slate-50 text-slate-900 shadow-sm"
                        placeholder="e.g. IV Therapy, EHR, EMR, CPR, Wound care"
                        autoFocus
                        required
                    />
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1.5">
                            Proficiency
                        </label>
                        <select
                            value={proficiency}
                            onChange={(e) => setProficiency(e.target.value)}
                            className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition-all bg-slate-50 text-slate-900 shadow-sm"
                        >
                            {proficiencyOptions.map(option => (
                                <option key={option} value={option}>{option}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1.5">
                            Experience (Years)
                        </label>
                        <input
                            type="number"
                            min="0"
                            step="0.5"
                            value={experience}
                            onChange={(e) => setExperience(e.target.value)}
                            className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition-all bg-slate-50 text-slate-900 shadow-sm"
                            placeholder="e.g. 2"
                        />
                    </div>
                </div>
            </div>
        </EditModalWrapper>
    );
};

export default AddSkillModal;
